import { render } from "./RocketSkin.vue?vue&type=template&id=12f3ddae&scoped=true&ts=true"
import script from "./RocketSkin.vue?vue&type=script&lang=ts"
export * from "./RocketSkin.vue?vue&type=script&lang=ts"

import "./RocketSkin.vue?vue&type=style&index=0&id=12f3ddae&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12f3ddae"]])

export default __exports__